import { useQuery } from '@tanstack/react-query';
import { type VesselViewModel } from '../../types';
import { apiClient } from '../../services/ApiClient';
import { ApiEndpoints } from '../../constants/api-constants';
import { Queries, QueryCacheConfig } from '../../constants/query-constants';

export const useGetVessel = (mmsi: string, enabled: boolean): VesselViewModel => {
  const getVessel = async (): Promise<any> => {
    return (await apiClient.get<VesselViewModel>(ApiEndpoints.vessels.getVessel(mmsi))) ?? [];
  };

  const { data } = useQuery({
    ...QueryCacheConfig[Queries.Vessel],
    queryKey: [Queries.Vessel, mmsi],
    queryFn: getVessel,
    enabled: !!mmsi && enabled,
  });

  return data;
};
